import { SharepointFileSelectDialog } from '@/components/dialogs/SharepointFileSelectDialog';
import { useAskAIContext } from '@/context/AskAiContext';
import React from 'react';

const AskAiSelectFilesDialog = () => {
	const {
		addSelectedSources,
		closeSelectFiles,
		isSelectFilesOpen,
		sharepointDriveId,
		sharepointItemId,
	} = useAskAIContext();

	return (
		<SharepointFileSelectDialog
			open={isSelectFilesOpen}
			onClose={closeSelectFiles}
			onConfirm={addSelectedSources}
			itemId={sharepointItemId}
			driveId={sharepointDriveId}
		/>
	);
};

export default AskAiSelectFilesDialog;
